interface PayWallBlockProps {}

export default function PayWallBlock({}: PayWallBlockProps): JSX.Element {
    return (
        <div className=" w-full h-[250px] bg-gradient-to-t from-white via-white/70 dark:from-gray-900 dark:via-gray-900/80 to-transparence" />
    );
}
